<template>
  <!--begin::Content wrapper-->
  <input type="hidden" id="ClassId" name="" value="" />

  <div
    dir="rtl"
    class="modal fade video-modal-wrapper"
    id="video-modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered video-modal-dialog">
      <div class="modal-content video-modal-content">
        <div class="modal-header video-modal-header">
          <div class="header-title-wrapper">
            <div class="video-icon-wrapper">
              <i class="fas fa-play"></i>
            </div>
            <h5 class="modal-title video-title">مشاهدة الدرس</h5>
          </div>
          <div class="header-actions">
            <button
              type="button"
              class="action-btn share-btn"
              @click="shareVideo"
              title="مشاركة الرابط"
            >
              <i class="fa fa-share-alt"></i>
              <span>مشاركة</span>
            </button>
            <button type="button" class="close-btn" data-bs-dismiss="modal">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>

        <div class="modal-body video-modal-body">
          <!-- ✅ الفيديو -->
          <div class="video-container">
            <div class="video-box text-center" id="video-loader"></div>
            <div class="video-box video-player" id="video-section"></div>
          </div>

          <!-- ✅ قسم الملاحظات -->
          <div class="notes-section">
            <div class="notes-header">
              <div class="notes-title-wrapper">
                <i class="fas fa-sticky-note"></i>
                <h5>الملاحظات</h5>
              </div>
              <button class="add-note-btn" @click="openNoteModal()">
                <i class="fa fa-plus"></i>
                <span>إضافة ملاحظة</span>
              </button>
            </div>

            <div v-if="qbankNotes && qbankNotes.length" class="notes-list">
              <div v-for="note in qbankNotes" :key="note.id" class="note-card">
                <div class="note-content">
                  <div class="note-meta">
                    <div class="note-user">
                      <i class="fas fa-user-circle"></i>
                      <span>{{ note.user?.name || "مستخدم غير معروف" }}</span>
                    </div>
                    <div class="note-time">
                      <i class="fas fa-clock"></i>
                      <span>{{ formatTime(note.timestamp) }}</span>
                    </div>
                  </div>
                  <p class="note-text">{{ note.note }}</p>
                  <div class="note-actions">
                    <button class="edit-btn" @click="openNoteModal(note)">
                      <i class="fa fa-edit"></i>
                      <span>تعديل</span>
                    </button>
                    <button class="delete-btn" @click="deleteNote(note.id)">
                      <i class="fa fa-trash"></i>
                      <span>حذف</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="empty-notes">
              <i class="fas fa-clipboard-list"></i>
              <p>لا توجد ملاحظات بعد</p>
              <span>أضف ملاحظة لتذكر النقاط المهمة</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ✅ مودال إضافة/تعديل ملاحظة -->
  <div
    class="modal fade note-modal-wrapper"
    id="noteModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content note-modal-content">
        <div class="modal-header note-modal-header">
          <div class="header-title-wrapper">
            <div class="note-icon-wrapper">
              <i class="fas fa-pen"></i>
            </div>
            <h5 class="modal-title">
              {{ editingNote ? "تعديل ملاحظة" : "إضافة ملاحظة" }}
            </h5>
          </div>
          <button type="button" class="close-btn" data-bs-dismiss="modal">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body note-modal-body">
          <form @submit.prevent="saveNote">
            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-align-left"></i>
                النص
              </label>
              <textarea
                v-model="noteForm.note"
                class="form-control note-textarea"
                rows="8"
                placeholder="اكتب ملاحظتك هنا..."
                required
              ></textarea>
            </div>

            <button type="submit" class="save-note-btn">
              <i class="fas fa-save"></i>
              {{ editingNote ? "تحديث الملاحظة" : "حفظ الملاحظة" }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api";

export default {
  name: "VideoClass",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      qbankNotes: [],
      isLoading: false,
      editingNote: null,
      noteForm: {
        note: "",
        timestamp: "",
      },
    };
  },
  methods: {
    async showClassNotes() {
      let ClassId = document.getElementById("ClassId").value;
      this.isLoading = true;
      try {
        const response = await fetch(
          `${apiUrl}/course-classes/${ClassId}/notes`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
              "x-country-code": window.appRegion.phone_code,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          this.qbankNotes = data.data;
        } else {
          console.error("Failed to fetch notes");
        }
      } catch (error) {
        console.error("Error fetching notes:", error);
      } finally {
        this.isLoading = false;
      }
    },

    formatTime(time) {
      return time ? time.split(".")[0] : "";
    },

    openNoteModal(note = null) {
      this.editingNote = note;
      if (note) {
        this.noteForm = { note: note.note, timestamp: note.timestamp };
      } else {
        this.noteForm = { note: "", timestamp: "" };
      }
      new bootstrap.Modal(document.getElementById("noteModal")).show();
    },

    async saveNote() {
      try {
        if (this.editingNote) {
          // ✅ تعديل مع تأكيد
          Swal.fire({
            title: "هل تريد حفظ التعديلات؟",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#00c744",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "نعم، حفظ",
            cancelButtonText: "إلغاء",
          }).then(async (result) => {
            if (result.isConfirmed) {
              const response = await fetch(
                `${apiUrl}/course-classes/note/update`,
                {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${this.token}`,
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    note_id: this.editingNote.id,
                    note: this.noteForm.note,
                  }),
                }
              );
              if (response.ok) {
                Swal.fire("تم", "تم تحديث الملاحظة بنجاح", "success");
                this.showClassNotes();
                bootstrap.Modal.getInstance(
                  document.getElementById("noteModal")
                ).hide();
              }
            }
          });
        } else {
          // ✅ إضافة
          let ClassId = document.getElementById("ClassId").value;
          let videoCurrentTime =
            document.getElementById("videoCurrentTime").value;

          function formatTime(seconds) {
            const sec = Math.floor(seconds % 60);
            const min = Math.floor((seconds % 3600) / 60);
            const hrs = Math.floor(seconds / 3600);
            return [hrs, min, sec].map((v) => (v < 10 ? "0" + v : v)).join(":");
          }
          let formattedTime = formatTime(videoCurrentTime);

          const response = await fetch(`${apiUrl}/course-classes/note`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
              "x-country-code": window.appRegion.phone_code,
            },
            body: JSON.stringify({
              note: this.noteForm.note,
              timestamp: formattedTime,
              course_class_id: ClassId,
            }),
          });
          if (response.ok) {
            Swal.fire("تم", "تمت إضافة الملاحظة بنجاح", "success");
            this.showClassNotes();
            bootstrap.Modal.getInstance(
              document.getElementById("noteModal")
            ).hide();
          }
        }
      } catch (error) {
        Swal.fire("خطأ", "حدثت مشكلة في العملية", "error");
      }
    },

    async deleteNote(id) {
      Swal.fire({
        title: "هل أنت متأكد؟",
        text: "لا يمكنك التراجع بعد الحذف",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "نعم، احذف",
        cancelButtonText: "إلغاء",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await fetch(`${apiUrl}/course-classes/note`, {
              method: "DELETE",
              headers: {
                Authorization: `Bearer ${this.token}`,
                "Content-Type": "application/json",
                "x-country-code": window.appRegion.phone_code,
              },
              body: JSON.stringify({ note_id: id }),
            });
            if (response.ok) {
              Swal.fire("تم", "تم حذف الملاحظة", "success");
              this.showClassNotes();
            }
          } catch (error) {
            Swal.fire("خطأ", "تعذر حذف الملاحظة", "error");
          }
        }
      });
    },

    async shareVideo() {
      try {
        // Get the current video ID from the hidden input
        const videoId = document.getElementById("ClassId").value;
        if (!videoId) {
          throw new Error("لم يتم العثور على معرّف الفيديو");
        }

        // Get current URL and its parameters
        const currentUrl = new URL(window.location.href);

        // Update or add the vc parameter
        currentUrl.searchParams.set("vc", videoId);

        // Get the full URL with all parameters
        const shareUrl = currentUrl.toString();

        try {
          // Try modern clipboard API first
          await navigator.clipboard.writeText(shareUrl);
          this.showSuccessMessage(shareUrl);
        } catch (err) {
          console.error("Failed to copy URL with modern API: ", err);
          // Fallback for browsers that don't support clipboard API
          await this.fallbackCopyToClipboard(shareUrl);
        }
      } catch (error) {
        console.error("Error in shareVideo:", error);
        Swal.fire({
          title: "خطأ",
          text: "حدث خطأ أثناء محاولة نسخ الرابط",
          icon: "error",
          confirmButtonText: "حسناً",
          confirmButtonColor: "#f64e60",
        });
      }
    },

    showSuccessMessage(shareUrl) {
      return Swal.fire({
        title: "تم النسخ بنجاح",
        html: `
          <div dir="rtl">
            <p>تم نسخ رابط الفيديو بنجاح</p>
            <p> يمكنك الان مشاركته</p>
          </div>
        `,
        icon: "success",
        confirmButtonText: "حسناً",
        confirmButtonColor: "#00c744",
      });
    },

    fallbackCopyToClipboard(shareUrl) {
      return new Promise((resolve, reject) => {
        const textArea = document.createElement("textarea");
        textArea.value = shareUrl;
        textArea.style.position = "fixed";
        textArea.style.opacity = 0;
        document.body.appendChild(textArea);
        textArea.select();

        try {
          const successful = document.execCommand("copy");
          document.body.removeChild(textArea);

          if (successful) {
            this.showSuccessMessage(shareUrl);
            resolve();
          } else {
            throw new Error("فشل نسخ الرابط");
          }
        } catch (err) {
          document.body.removeChild(textArea);
          reject(err);
        }
      });
    },
  },
};
</script>

<style scoped>
/* ===== Premium Video Modal Styles ===== */

/* Modal Animation */
@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Modal Dialog - Large & Immersive */
.video-modal-dialog {
  max-width: 95vw;
  width: 1200px;
  margin: 1rem auto;
}

@media (min-width: 1400px) {
  .video-modal-dialog {
    max-width: 1300px;
  }
}

@media (max-width: 768px) {
  .video-modal-dialog {
    max-width: 98vw;
    margin: 0.5rem auto;
  }
}

/* Modal Content - Premium Glass Effect */
.video-modal-content {
  border: none;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(0, 199, 68, 0.1), 0 30px 100px rgba(0, 0, 0, 0.3),
    0 15px 50px rgba(0, 199, 68, 0.15);
  animation: modalFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  background: white;
}

/* Modal Header - Elegant Gradient */
.video-modal-header {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 50%, #009934 100%);
  padding: 20px 30px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}

.video-modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
}

.header-title-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  z-index: 1;
}

.video-icon-wrapper {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.video-icon-wrapper i {
  color: white;
  font-size: 1.4rem;
}

.video-title {
  color: white;
  font-size: 1.35rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  letter-spacing: -0.02em;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  z-index: 1;
}

.action-btn.share-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  color: white;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.action-btn.share-btn:hover {
  background: rgba(255, 255, 255, 0.35);
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.action-btn.share-btn i {
  color: white !important;
  font-size: 1rem;
}

.close-btn {
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  backdrop-filter: blur(10px);
}

.close-btn i {
  color: white;
  font-size: 1.1rem;
  transition: transform 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.close-btn:hover i {
  transform: rotate(90deg);
}

/* Modal Body - Clean & Spacious */
.video-modal-body {
  padding: 0;
  background: #fafffe;
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #00c744 #e8fff1;
}

.video-modal-body::-webkit-scrollbar {
  width: 8px;
}

.video-modal-body::-webkit-scrollbar-track {
  background: #e8fff1;
  border-radius: 10px;
}

.video-modal-body::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #00c744, #00a83b);
  border-radius: 10px;
}

.video-modal-body::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #00a83b, #008f32);
}

/* Video Container - Immersive */
.video-container {
  background: #fafffe;
  padding: 20px;
  padding-bottom: 0;
}

.video-player {
  width: 100%;
  min-height: 600px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

@media (min-width: 1200px) {
  .video-player {
    min-height: 650px;
  }
}

@media (max-width: 768px) {
  .video-player {
    min-height: 300px;
  }

  .video-modal-header {
    padding: 15px 20px;
  }

  .video-title {
    font-size: 1.1rem;
  }

  .video-icon-wrapper {
    width: 40px;
    height: 40px;
  }

  .action-btn.share-btn {
    padding: 10px 16px;
    font-size: 0.85rem;
  }

  .action-btn.share-btn span {
    display: none;
  }
}

/* Notes Section - Premium Design */
.notes-section {
  padding: 30px;
  background: linear-gradient(180deg, #fafffe 0%, #f0fff6 100%);
  border-top: 1px solid rgba(0, 199, 68, 0.1);
}

.notes-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 2px solid rgba(0, 199, 68, 0.1);
}

.notes-title-wrapper {
  display: flex;
  align-items: center;
  gap: 14px;
}

.notes-title-wrapper i {
  color: #00c744;
  font-size: 1.4rem;
}

.notes-title-wrapper h5 {
  margin: 0;
  color: #1a202c;
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.add-note-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  border: none;
  border-radius: 50px;
  color: white;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 6px 20px rgba(0, 199, 68, 0.35);
}

.add-note-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 199, 68, 0.45);
}

.add-note-btn i {
  color: white !important;
  font-size: 0.9rem;
}

.notes-list {
  padding-right: 8px;
}

.note-card {
  background: white;
  border-radius: 18px;
  margin-bottom: 16px;
  border: 1px solid rgba(0, 199, 68, 0.1);
  border-right: 5px solid #00c744;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
}

.note-card:hover {
  transform: translateX(-8px);
  box-shadow: 0 15px 40px rgba(0, 199, 68, 0.12);
  border-color: rgba(0, 199, 68, 0.3);
}

.note-content {
  padding: 22px 24px;
}

.note-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.note-user,
.note-time {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
}

.note-user {
  color: #1a202c;
  font-weight: 600;
}

.note-user i {
  color: #00c744;
  font-size: 1.1rem;
}

.note-time {
  color: #718096;
  font-size: 0.85rem;
}

.note-time i {
  color: #00c744;
  font-size: 0.8rem;
}

.note-text {
  color: #4a5568;
  font-size: 1rem;
  line-height: 1.7;
  margin: 0 0 18px 0;
}

.note-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.edit-btn,
.delete-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border: none;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.edit-btn {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(0, 199, 68, 0.25);
}

.edit-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 199, 68, 0.3);
}

.edit-btn i {
  color: white !important;
}

.delete-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
}

.delete-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(239, 68, 68, 0.35);
}

.delete-btn i {
  color: white !important;
}

/* Empty Notes - Premium Design */
.empty-notes {
  text-align: center;
  padding: 50px 30px;
  background: white;
  border-radius: 20px;
  border: 2px dashed rgba(0, 199, 68, 0.3);
  transition: all 0.3s ease;
}

.empty-notes:hover {
  border-color: rgba(0, 199, 68, 0.5);
  background: linear-gradient(135deg, #fafffe 0%, #f0fff6 100%);
}

.empty-notes i {
  font-size: 4rem;
  color: rgba(0, 199, 68, 0.3);
  margin-bottom: 20px;
  display: block;
}

.empty-notes p {
  color: #1a202c;
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.empty-notes span {
  color: #718096;
  font-size: 0.95rem;
}

/* Note Modal Styles - Premium */
.note-modal-content {
  border: none;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(0, 199, 68, 0.1), 0 25px 80px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.note-modal-header {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 50%, #009934 100%);
  padding: 20px 28px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}

.note-modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
}

.note-icon-wrapper {
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 1;
}

.note-icon-wrapper i {
  color: white;
  font-size: 1.1rem;
}

.note-modal-header .modal-title {
  color: white;
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.note-modal-body {
  padding: 30px;
  background: linear-gradient(180deg, #fafffe 0%, #f0fff6 100%);
}

.form-group {
  margin-bottom: 24px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1a202c;
  font-weight: 700;
  margin-bottom: 12px;
  font-size: 1rem;
}

.form-label i {
  color: #00c744;
  font-size: 1.1rem;
}

.note-textarea {
  width: 100%;
  min-height: 180px;
  padding: 18px;
  border: 2px solid rgba(0, 199, 68, 0.15);
  border-radius: 16px;
  font-size: 1rem;
  resize: vertical;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  background: white;
  line-height: 1.6;
}

.note-textarea:focus {
  outline: none;
  border-color: #00c744;
  box-shadow: 0 0 0 5px rgba(0, 199, 68, 0.1);
}

.note-textarea::placeholder {
  color: #a0aec0;
}

.save-note-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 16px 28px;
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  border: none;
  border-radius: 50px;
  color: white;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 10px 35px rgba(0, 199, 68, 0.35);
}

.save-note-btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 15px 45px rgba(0, 199, 68, 0.45);
}

.save-note-btn i {
  color: white !important;
  font-size: 1rem;
}

/* Dark Mode Support */
[data-bs-theme="dark"] .video-modal-content,
[data-theme="dark"] .video-modal-content,
.dark .video-modal-content {
  background: #1e293b;
}

[data-bs-theme="dark"] .video-modal-body,
[data-theme="dark"] .video-modal-body,
.dark .video-modal-body {
  background: #0f172a;
}

[data-bs-theme="dark"] .notes-section,
[data-theme="dark"] .notes-section,
.dark .notes-section {
  background: linear-gradient(135deg, #0f172a 0%, #1a2744 100%);
}

[data-bs-theme="dark"] .notes-title-wrapper h5,
[data-theme="dark"] .notes-title-wrapper h5,
.dark .notes-title-wrapper h5 {
  color: #f1f5f9;
}

[data-bs-theme="dark"] .note-card,
[data-theme="dark"] .note-card,
.dark .note-card {
  background: #1e293b;
  border-color: #2d3748;
}

[data-bs-theme="dark"] .note-user,
[data-theme="dark"] .note-user,
.dark .note-user {
  color: #f1f5f9;
}

[data-bs-theme="dark"] .note-text,
[data-theme="dark"] .note-text,
.dark .note-text {
  color: #cbd5e1;
}

[data-bs-theme="dark"] .empty-notes,
[data-theme="dark"] .empty-notes,
.dark .empty-notes {
  background: #1e293b;
  border-color: #2d3748;
}

[data-bs-theme="dark"] .empty-notes p,
[data-theme="dark"] .empty-notes p,
.dark .empty-notes p {
  color: #f1f5f9;
}

[data-bs-theme="dark"] .note-modal-body,
[data-theme="dark"] .note-modal-body,
.dark .note-modal-body {
  background: linear-gradient(135deg, #0f172a 0%, #1a2744 100%);
}

[data-bs-theme="dark"] .form-label,
[data-theme="dark"] .form-label,
.dark .form-label {
  color: #f1f5f9;
}

[data-bs-theme="dark"] .note-textarea,
[data-theme="dark"] .note-textarea,
.dark .note-textarea {
  background: #1e293b;
  border-color: #2d3748;
  color: #f1f5f9;
}

[data-bs-theme="dark"] .note-textarea::placeholder,
[data-theme="dark"] .note-textarea::placeholder,
.dark .note-textarea::placeholder {
  color: #64748b;
}

[data-bs-theme="dark"] .video-container,
[data-theme="dark"] .video-container,
.dark .video-container {
  background: #0f172a;
}

[data-bs-theme="dark"] .note-modal-content,
[data-theme="dark"] .note-modal-content,
.dark .note-modal-content {
  background: #1e293b;
}

[data-bs-theme="dark"] .notes-header,
[data-theme="dark"] .notes-header,
.dark .notes-header {
  border-bottom-color: rgba(0, 199, 68, 0.2);
}

[data-bs-theme="dark"] .note-card:hover,
[data-theme="dark"] .note-card:hover,
.dark .note-card:hover {
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);
}

[data-bs-theme="dark"] .empty-notes span,
[data-theme="dark"] .empty-notes span,
.dark .empty-notes span {
  color: #94a3b8;
}

[data-bs-theme="dark"] .close-btn,
[data-theme="dark"] .close-btn,
.dark .close-btn {
  background: rgba(255, 255, 255, 0.1);
}

[data-bs-theme="dark"] .close-btn:hover,
[data-theme="dark"] .close-btn:hover,
.dark .close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}
</style>
